module.exports = require("./fr-BJ.d.ts");